export enum Client {
  TPN = 'tpn',
  PNGS = 'pngs',
  Messe = 'messe',
}
